import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useDispatch } from 'react-redux';
import { toggleModal } from '../../../reducers/modalReducer.js';
import Certification from "../../../components/Certification";
import PricingColumn from "../../../components/PricingColumn";
import SubscriptionPaymentConfirm from '../../../components/modals/SubscriptionPaymentConfirm/SubscriptionPaymentConfirm.jsx';

export default function Certificates({ company, setTab, directors }) {
	const dispatch = useDispatch();
	let [payload, setPayload] = useState(null);
	let [showExpension, setShowExpension] = useState(null);
	const [linearProgress, setLinearProgress] = useState(25);
	const [disabledCertificates, setDisabledCertificates] = useState(true);

	useEffect(() => {
		if (['Lite', 'Free'].includes(company['subscription'])) setDisabledCertificates(true);
		else setDisabledCertificates(false);

		// Set Linear Progress
		if (company['cLevel'] == 'Bronze') setLinearProgress(50);
		else if (company['cLevel'] == 'Silver') setLinearProgress(75);
		else if (company['cLevel'] == 'Gold') setLinearProgress(100);
		else setLinearProgress(25);
	}, [company]);

	return (
		<>
			<div className="certificates-page">
				{company['points'] &&
					<>
						{/* {disabledCertificates &&
						<div className="left-upgrade-button">
							<Link className="ass fs1rem pt0-75rem data-check-box" to={`/billing/${company['_id']}`} >
								<h3 className='c6'>* Certification Requires Upgrade To Pro</h3>
							</Link>
						</div>
					} */}
						<div className={disabledCertificates && 'disabled-certificates-page'}>
							<div className="badges-sec c2 br20px df jcsb aife" style={{ backgroundColor: '#2947EF1A', border: '1px solid #7385BE80' }}>
								<div className="pt1rem pl2rem pb1rem df">
									<div className="badges-area w100">
										<div className="certificates-current w100">
											<div className='top-heading'>
												<h2 className='c15'>Your Progress</h2>
												<h4 style={{ color: '#44D991' }}>PRO Only</h4>
												<p className='ass fs0-75rem df aic'>
													{/* <span className='mr0-5rem'>Current status:</span> */}
													{company['cLevel'] === "None" ? <img src={require('../../../../images/dashboard/certifications/noneStar.png')} alt="noneStar" /> : company['cLevel'] === "Bronze" ? <img src={require('../../../../images/dashboard/certifications/bronzeStar.png')} alt="bronzeStar" /> : company['cLevel'] === "Silver" ? <img src={require('../../../../images/dashboard/certifications/silverStar.png')} alt="silverStar" /> : <img src={require('../../../../images/dashboard/certifications/goldStar.png')} alt="goldStar" />}

													<span className='ml0-5rem c15 op70 fsi fs1-25rem'>{company['cLevel'] ? company['cLevel'] === "None" ? 'Not Yet Certified' : company['cLevel'] : 'Not Yet Certified'}</span>

												</p>
											</div>
											<div className="df ">
												{company['points'] && <span className="packge-select" style={{ width: '100%' }}>
													<div className={`px1rem ${company['cLevel'] == 'None' && 'current'}`}>
														<Certification className={`z12 `} component='Certificates' level='None' subscription={company['subscription']} expiryTimestamp={company['createdAt']} company={company} />
														{/* {!disabledCertificates && company['cLevel'] == 'None' &&
														<div className="df jcc">
															<img src={require('../../../../images/active.png')} alt="active" style={{ width: '20px', height: '15px', margin: '4px 4px 0px' }} />
															<p className="ass fs1rem">Current Status</p>
														</div>
													} */}
													</div>
													<div className={`px1rem ${company['cLevel'] == 'Bronze' && 'current'}`}>
														<Certification className={`z12 `} component='Certificates' level='Bronze' subscription={company['subscription']} expiryTimestamp={company['createdAt']} company={company} />
														{/* {!disabledCertificates && company['cLevel'] == 'Bronze' &&
															<div className="df jcc">
																<img src={require('../../../../images/active.png')} alt="active" style={{ width: '20px', height: '15px', margin: '4px 4px 0px' }} />
																<p className="current-badge ass fs1rem">Current Status</p>
															</div>
														} */}
													</div>
													<div className={`px1rem ${company['cLevel'] == 'Silver' && 'current'}`}>
														<Certification className={`z12 `} component='Certificates' level='Silver' subscription={company['subscription']} expiryTimestamp={company['createdAt']} company={company} />
														{/* {!disabledCertificates && company['cLevel'] == 'Silver' &&
															<div className="df jcc">
																<img src={require('../../../../images/active.png')} alt="active" style={{ width: '20px', height: '15px', margin: '4px 4px 0px' }} />
																<p className="current-badge ass fs1rem">Current Status</p>
															</div>
														} */}
													</div>
													<div className={`px1rem ${company['cLevel'] == 'Gold' && 'current'}`}>
														<Certification className={`z12`} component='Certificates' level='Gold' subscription={company['subscription']} expiryTimestamp={company['createdAt']} company={company} />
														{/* {!disabledCertificates && company['cLevel'] == 'Gold' &&
															<div className="df jcc">
																<img src={require('../../../../images/active.png')} alt="active" style={{ width: '20px', height: '15px', margin: '4px 4px 0px' }} />
																<p className="current-badge ass fs1rem">Current Status</p>
															</div>
														} */}
													</div>
												</span>
												}


											</div>

											<div className='p1rem w100'>
												{!disabledCertificates && <>
													{company['certificateNext'] &&
														<Box sx={{ width: '100%' }}>
															<div className='certificate-progress-bar certificate-progress-bar-custom'>
																<ProgressBar now={linearProgress} />
															</div>
														</Box>}
												</>}
											</div>
										</div>
									</div>
								</div>

								<img src={require('../../../../images/dashboard/certifications/cards/certificategirl.png')} alt="certification-bg" className="certification-bg" style={{ maxWidth: '600px', height: 'auto' }} />
							</div>


							{/* Requirements for certification progress */}
							<div className="mt2rem br20px pt2rem pl2rem pb1rem" style={{ backgroundColor: '#fff', border: '1px solid #DBDFEE' }}>
								<div className="progress-sec">
									<div style={{ paddingLeft: '10px' }}>
										<h2 className='c15'> Requirements for certification progress</h2>
										<h4 style={{ color: '#44D991' }}>PRO Only</h4>
									</div>
									<div className="container">
										<div className="data-check-sec">
											<div className="dg gg2rem gtcr3">
												<div className="jcsb data-check-box">
													<div className="df aic mb2rem">
														<img src={require('../../../../images/dashboard/certifications/cards/bronze.png')} alt="bronzeStar" style={{ width: '80px', height: '100px' }} />
														<div className='df fdc jcfs aifs ml1rem'>
															<h4 className='c15 fs1-25rem lh1 w100 tal'>Bronze</h4>
															<span className='c27 fs0-75rem lh1'>Unaudited Certification Progress</span>
														</div>
													</div>

													<ul className="data-list">
														<li className={!disabledCertificates && company['points']['Bronze']['p1'] && 'check'}>

															{75 < company?.['modules']?.['repository']?.['stats']?.['completionPercent'] ? <img src={require('../../../../images/dashboard/certifications/check.svg')} alt="bronzeStar" className='pa' style={{ width: '24px', height: '24px', marginLeft: '-2px', marginTop: '-2px', left: '12px', top: '4px' }} /> : <span className="icon round"></span>}
															<h4 className='c74'>Data Repository</h4>
															<div className="dg gtcr2">
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																<p className='c15 fs1rem'>Completness &gt; <span className="c7"> 75%</span></p>
																<p className='c15 fs1rem br20px' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>Completness &gt; <span className="c7">{company?.['modules']?.['repository']?.['stats']?.['completionPercent'] || 0}%</span></p>
															</div>

														</li>
														<li className={!disabledCertificates && company['points']['Bronze']['p2'] && 'check'}>
															{(75 < company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] && 50 > company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent']) ? <img src={require('../../../../images/dashboard/certifications/check1.svg')} alt="bronzeStar" className='pa' style={{ width: '24px', height: '24px', marginLeft: '-2px', marginTop: '-2px', left: '12px', top: '4px' }} /> : <span className="icon round"></span>}
															<h4 className='c74'>Business Audit</h4>

															<div className="dg gtcr2">
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																<div className='c15 df fdc aifs jcfs'>
																	<p className='df aic w100'>Completness &gt; <span className="c7">  75%</span>
																	</p>
																	<p className='df aic w100'>Risk &lt;
																		<span className="c9"> 50%</span>
																	</p>
																</div>
																<div>
																	<div className='c15 fs1rem br20px' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																		<p className='df aic w100'>
																			Completness &gt;
																			<span className="c7">{company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] || 0}%</span>
																		</p>
																	</div>
																	<div className='c15 fs1rem br20px mt0-5rem' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																		<p className='df aic w100'>Risk -
																			<span className="c9"> {company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent'] || 0}%</span></p>
																	</div>
																</div>
															</div>
														</li>
													</ul>
												</div>

												{/* Silver card */}
												<div className="jcsb data-check-box">
													<div className="df aic mb2rem">
														<img src={require('../../../../images/dashboard/certifications/cards/silver.png')} alt="bronzeStar" style={{ width: '80px', height: '100px' }} />
														<div className='df fdc jcfs aifs ml1rem'>
															<h4 className='c15 fs1-25rem lh1 w100 tal'>Silver</h4>
															<span className='c27 fs0-75rem lh1'>Unaudited Certification Progress</span>
														</div>
													</div>
													<ul className="data-list">
														<li className={!disabledCertificates && company['points']['Silver']['p1'] && 'check'}>
															{75 < company?.['modules']?.['repository']?.['stats']?.['completionPercent'] ? <img src={require('../../../../images/dashboard/certifications/check.svg')} alt="bronzeStar" className='pa' style={{ width: '24px', height: '24px', marginLeft: '-2px', marginTop: '-2px', left: '12px', top: '4px' }} /> : <span className="icon round"></span>}

															<h4 className='c74'>Data Repository</h4>
															<div className="dg gtcr2">
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																<p className='c15 fs1rem'>Completness &gt; <span className="c7"> 	90%</span></p>
																<div className='c15 fs1rem br20px' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																	{
																		['silver', 'gold'].includes(company['cLevel']?.toLowerCase()) ? <> <p className='w100 tal'>Completness &gt; <span className="c7 w100 tal">
																			{company?.['modules']?.['repository']?.['stats']?.['completionPercent'] || 0}%
																		</span></p>
																		</> : <p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>NIL</p>
																	}
																</div>
															</div>
														</li>

														<li className={!disabledCertificates && company['points']['Silver']['p2'] && 'check'}>
															{(75 < company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] && 50 > company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent']) ? <img src={require('../../../../images/dashboard/certifications/check1.svg')} alt="bronzeStar" className='pa' style={{ width: '24px', height: '24px', marginLeft: '-2px', marginTop: '-2px', left: '12px', top: '4px' }} /> : <span className="icon round"></span>}
															<h4 className='c74'>Business Audit</h4>
															<div className="dg gtcr2">
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																<div className='c15 df fdc aifs jcfs'>
																	<p className='df aic w100'>Completness &gt; <span className="c7">  90%</span>
																	</p>
																	<p className='df aic w100'>Risk &lt;
																		<span className="c9"> 50%</span>
																	</p>
																</div>
																<div>
																	<div className='c15 fs1rem br20px' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>

																		{
																			['silver', 'gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																				<p className='df aic w100'>
																					Completness &gt;
																					<span className="c7">{company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] || 0}%</span></p> </> :
																				<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>NIL</p>
																		}


																	</div>
																	<div className='c15 fs1rem br20px mt0-5rem' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																		{
																			['silver', 'gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																				<p className='df aic w100'>Risk -
																					<span className="c9"> {company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent'] || 0}%</span></p>
																			</> :
																				<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>NIL</p>
																		}
																	</div>
																</div>
															</div>
														</li>

														<li className={!disabledCertificates && company['points']['Silver']['p3'] && 'check'}>
															<span className="icon round"></span>
															<span className="icon check"><img src={require(`../../../../images/dashboard/certifications/check.svg`)} alt="" /></span>
															<div className="df jcsb" style={{ columnGap: '1rem' }}>
																<div className='w100'>
																	<h4 className='c74'>Warranty Disclosure Schedule</h4>
																	<div className="dg gtcr2">
																		<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																		<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>

																		<p className='c15 fs1rem'>Completness &gt; <span className="c7"> 75%</span></p>
																		<div className='c15 fs1rem br20px mt0-5rem' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																			{
																				['silver', 'gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																					<p className='w100 tal'>Completness &gt; <span className="c7">{company?.['modules']?.[`warranty-disclosure`]?.['stats']?.['riskPercent'] || 0}%</span>
																					</p>
																				</> :
																					<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>NIL</p>
																			}
																		</div>
																	</div>
																</div>
																{(disabledCertificates || !company?.['modules']?.[`warranty-disclosure`]) && <div className="bg4 c1 br20px tac df aic jcc" style={{ padding: '4px 12px', width: '80px', maxHeight: '32px' }}
																	onClick={() => {
																		dispatch(toggleModal({ open: 'subscriptionPaymentConfirm' }));
																		setShowExpension('DEPF006')
																	}}
																>
																	Buy
																</div>}
															</div>

														</li>
														<li className={!disabledCertificates && company['points']['Silver']['p4'] && 'check'}>
															<span className="icon round"></span>
															<span className="icon check"><img src={require(`../../../../images/dashboard/certifications/check.svg`)} alt="" /></span>
															<div className="df jcsb">
																<div className='w100'>
																	<h4 className='c74'>Draft Director’s Questionnaires</h4>
																	<div className="dg gtcr2">
																		<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																		<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																		<div className='c15 df fdc aifs jcfs'>
																			<p className='df aic w100'>Completness &gt; <span className="c7"> 75%</span>
																			</p>
																			<p className='df aic w100'>Risk &gt;
																				<span className="c9"> 50%</span>
																			</p>
																		</div>
																		<div>
																			<div className='c15 fs1rem br20px' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																				{
																					['silver', 'gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																						<p className='df aic w100'>
																							Completness &gt;
																							<span className="c7">{company?.['modules']?.[[`directors-questionnaire-${directors?.[0]?.['_id']}`]]?.['stats']?.['completionPercent'] || 0}%</span>
																						</p>
																					</> :
																						<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>
																							NIL
																						</p>
																				}
																			</div>
																			<div className='c15 fs1rem br20px mt0-5rem' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>

																				{
																					['silver', 'gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																						<p className='df aic w100'>Risk -
																							<span className="c9"> {company?.['modules']?.[[`directors-questionnaire-${directors?.[0]?.['_id']}`]]?.['stats']?.['riskPercent'] || 0}%</span></p>
																					</> :
																						<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>
																							NIL
																						</p>
																				}
																			</div>
																		</div>
																	</div>
																</div>
																{(disabledCertificates || !company?.['modules']?.[[`directors-questionnaire-${directors?.[0]?.['_id']}`]]?.['stats']?.['completionPercent']) && <div className="bg4 c1 br20px tac df aic jcc" style={{ padding: '4px 12px', width: '80px', maxHeight: '32px' }}
																	onClick={() => {
																		dispatch(toggleModal({
																			open: 'subscriptionPaymentConfirm'
																		}));
																		setShowExpension('DEPF007')
																	}}
																>
																	Buy
																</div>}
															</div>
														</li>
													</ul>
												</div>


												{/* Gold card */}
												<div className="jcsb data-check-box">
													<div className="df aic mb2rem">
														<img src={require('../../../../images/dashboard/certifications/cards/gold.png')} alt="bronzeStar" style={{ width: '80px', height: '100px' }} />
														<div className='df fdc jcfs aifs ml1rem'>
															<h4 className='c15 fs1-25rem lh1 w100 tal'>Gold</h4>
															<span className='c27 fs0-75rem lh1'>Unaudited Certification Progress</span>
														</div>
													</div>
													<ul className="data-list">
														<li className={!disabledCertificates && company['points']['Gold']['p1'] && 'check'}>
															{75 < company?.['modules']?.['repository']?.['stats']?.['completionPercent'] ? <img src={require('../../../../images/dashboard/certifications/check.svg')} alt="bronzeStar" className='pa' style={{ width: '24px', height: '24px', marginLeft: '-2px', marginTop: '-2px', left: '12px', top: '4px' }} /> : <span className="icon round"></span>}
															<h4 className='c74'>Data Repository</h4>
															<div className="dg gtcr2">
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																<p className='c15 fs1rem'>Completness &gt; <span className="c7"> 100%</span></p>
																<div
																	className='c15 fs1rem br20px'
																	style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}
																>


																	{
																		['gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																			<p className='w100 tal'>Completness &gt; <span className="c7">{company?.['modules']?.['repository']?.['stats']?.['completionPercent'] || 0}%</span></p>
																		</> :
																			<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>
																				NIL
																			</p>
																	}
																</div>
															</div>
														</li>
														<li className={!disabledCertificates && company['points']['Gold']['p2'] && 'check'}>
															{(75 < company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] && 50 > company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent']) ? <img src={require('../../../../images/dashboard/certifications/check1.svg')} alt="bronzeStar" className='pa' style={{ width: '24px', height: '24px', marginLeft: '-2px', marginTop: '-2px', left: '12px', top: '4px' }} /> : <span className="icon round"></span>}
															<h4 className='c74'	>Business Audit</h4>
															<div className="dg gtcr2">
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																<div className='c15 df fdc aifs jcfs'>
																	<p className='df aic w100'>Completness &gt; <span className="c7"> 100%</span>
																	</p>
																	<p className='df aic w100'>Risk &lt;
																		<span className="c9"> 25%</span>
																	</p>
																</div>
																<div>
																	<div className='c15 fs1rem br20px' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																		{
																			['gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																				<p className='df aic w100'>
																					Completness &gt;
																					<span className="c7">{company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] || 0}%</span>
																				</p>
																			</> :
																				<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>
																					NIL
																				</p>
																		}
																	</div>
																	<div className='c15 fs1rem br20px mt0-5rem' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																		{
																			['gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																				<p className='df aic w100'>Risk -
																					<span className="c9"> {company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent'] || 0}%</span></p>
																			</> :
																				<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>
																					NIL
																				</p>
																		}
																	</div>
																</div>
															</div>
														</li>

														<li className={!disabledCertificates && company['points']['Gold']['p3'] && 'check'}>
															{(90 < company?.['modules']?.[`warranty-disclosure`]?.['stats']?.['completionPercent']) ? <img src={require('../../../../images/dashboard/certifications/check.svg')} alt="bronzeStar" className='pa' style={{ width: '24px', height: '24px', marginLeft: '-2px', marginTop: '-2px', left: '12px', top: '4px' }} /> : <span className="icon round"></span>}

															<div className="df jcsb">
																<div className='w100'>
																	<h4 className='c74'>Warranty Disclosure Schedule</h4>
																	<div className="dg gtcr2">
																		<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																		<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																		<p className='c15 fs1rem'>Completness &gt; <span className="c7"> 90%</span></p>
																		<div className='c15 fs1rem br20px' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																			{
																				['gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																					<p className='w100 tal'>Completness &gt;
																						<span className="c7">{company?.['modules']?.[`warranty-disclosure`]?.['stats']?.['completionPercent'] || 0}%</span>
																					</p>
																				</> :
																					<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>
																						NIL
																					</p>
																			}
																		</div>
																	</div>
																</div>
																{disabledCertificates || !company?.['modules']?.[`warranty-disclosure`]?.['stats']?.['completionPercent'] && <div className="bg4 c1 br20px tac df aic jcc"
																	style={{ padding: '4px 12px', width: '80px', maxHeight: '32px' }}
																	onClick={() => {
																		dispatch(toggleModal({ open: 'subscriptionPaymentConfirm' }));
																		setShowExpension('DEPF006')
																	}}
																>
																	Buy
																</div>}
															</div>
														</li>
														<li className={!disabledCertificates && company['points']['Gold']['p4'] && 'check'}>
															{(90 < company?.['modules']?.[[`directors-questionnaire-${directors?.[0]?.['_id']}`]]?.['stats']?.['completionPercent'] && 50 > company?.['modules']?.[[`directors-questionnaire-${directors?.[0]?.['_id']}`]]?.['stats']?.['riskPercent']) ? <img src={require('../../../../images/dashboard/certifications/check.svg')} alt="bronzeStar" className='pa' style={{ width: '24px', height: '24px', marginLeft: '-2px', marginTop: '-2px', left: '12px', top: '4px' }} /> : <span className="icon round"></span>}

															<div className="df jcsb">
																<div className='w100'>
																	<h4 className='c74'>Draft Director’s Questionnaires</h4>
																	<div className="dg gtcr2">
																		<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Required Score:</p>
																		<p className='fw300' style={{ color: '#929090', fontSize: '14px' }}>Your Score:</p>
																		<div className='c15 df fdc aifs jcfs'>
																			<p className='df aic w100'>Completness &gt; <span className="c7">  90%</span>
																			</p>
																			<p className='df aic w100'>Risk &gt;
																				<span className="c9"> 50%</span>
																			</p>
																		</div>
																		<div className='w100'>
																			<div className='c15 fs1rem br20px' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																				{
																					['gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																						<p className='df aic w100'>
																							Completness &gt;
																							<span className="c7">{company?.['modules']?.[[`directors-questionnaire-${directors?.[0]?.['_id']}`]]?.['stats']?.['completionPercent'] || 0}%</span>
																						</p>
																					</> :
																						<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>
																							NIL
																						</p>
																				}
																			</div>
																			<div className='c15 fs1rem br20px mt0-5rem' style={{ backgroundColor: '#02BC7D21', padding: '4px 12px', maxWidth: '150px', textAlign: 'center' }}>
																				{
																					['gold'].includes(company['cLevel']?.toLowerCase()) ? <>
																						<p className='df aic w100'>Risk -
																							<span className="c9"> {company?.['modules']?.[[`directors-questionnaire-${directors?.[0]?.['_id']}`]]?.['stats']?.['riskPercent'] || 0}%</span></p>
																					</> :
																						<p className='fsi fw600 w100 tal' style={{ color: '#5E5F66', fontSize: '14px' }}>
																							NIL
																						</p>
																				}
																			</div>
																		</div>
																	</div>
																</div>
																{disabledCertificates || !company?.['modules']?.[[`directors-questionnaire-${directors?.[0]?.['_id']}`]]?.['stats']?.['completionPercent'] && <div className="bg4 c1 br20px tac df aic jcc"
																	style={{ padding: '4px 12px', width: '80px', maxHeight: '32px' }}
																	onClick={() => {
																		dispatch(toggleModal({
																			open: 'subscriptionPaymentConfirm'
																		}));
																		setShowExpension('DEPF007')
																	}}
																>
																	Buy
																</div>}
															</div>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>

								{/* <div className="footer-sec">
								<div className="container py2rem">
									<div className='check-box'>
										<p className="c2 tac">Audited <b>Certificates</b></p>
										<div className="certificates-current">
											<div className="df fdc">
												<span className="packge-select fw300 c4 lh1 fs3rem dg gg2rem gtcr3">
													<Certification className={'z12'} component='Certificates' level='None' subscription={company['subscription']} expiryTimestamp={company['createdAt']} company={company} />
													<Certification className={'z12'} component='Certificates' level='Bronze' subscription={company['subscription']} expiryTimestamp={company['createdAt']} company={company} />
													<Certification className={'z12'} component='Certificates' level='Silver' subscription={company['subscription']} expiryTimestamp={company['createdAt']} company={company} />
													<Certification className={'z12'} component='Certificates' level='Gold' subscription={company['subscription']} expiryTimestamp={company['createdAt']} company={company} />
												</span>
											</div>
										</div>
										<div className='center-text btn-back mt4rem mb3rem'>
											<Link to={`/billing/${company['_id']}`} className='upgrade-btns shadow bg3 c1 td250 br5px px1rem py0-5rem cp ttu bsbb tac jcc aic'>Upgrade to Pro PLUS</Link>
											<div className="certification-pricing-column">
												<PricingColumn plan="Pro PLUS" component="Certificates" />
											</div>
											<br />
											<img src={require('../../../../images/landingpage/book-call.png')} style={{ width: '15%' }} className="cp book-call" onClick={() => window.open('https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true', '_blank')} />
											<br />
											<button onClick={() => setTab('')} className='shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem cp ttu bsbb tac jcc aic'>Back</button>
										</div>
									</div>
								</div>
							</div> */}
							</div>
						</div>
					</>
				}
			</div>

			<SubscriptionPaymentConfirm
				plan={!showExpension ? 'Pro' : typeof showExpension === "string" ? showExpension : showExpension?.['moduleKey']}
				setShowExpension={setShowExpension}
				defaultStep={'modulePurchase'}
				company={company}
				companyId={company['_id']}
				payload={payload}
				module={showExpension}
				showExpension={showExpension}
			/>
		</>
	);
};
